import React, { MouseEvent } from "react";
import { Button } from "semantic-ui-react";

interface InspectionItemStaffPassFailButtonsProps {
  isFailLoading?: boolean;
  isPassLoading?: boolean;
  onFail?: () => void;
  onPass?: () => void;
}
export default function InspectionItemStaffPassFailButtons({
  isFailLoading = false,
  isPassLoading = false,
  onFail = () => {},
  onPass = () => {},
}: InspectionItemStaffPassFailButtonsProps) {
  const handlePass = (ev: MouseEvent) => {
    ev.stopPropagation();
    onPass();
  };

  const handleFail = (ev: MouseEvent) => {
    ev.stopPropagation();
    onFail();
  };

  return (
    <>
      <Button loading={isPassLoading} positive icon='check' className='tw-mr-6' onClick={handlePass} />
      <Button loading={isFailLoading} negative icon='cancel' onClick={handleFail} />
    </>
  );
}
